import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Permissions } from '../models/common.model';
import { StorageService } from './storage.service';
import { BackEndCommunicationService } from './beComm.service';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private token: string;
  private isBBRAdmin: boolean;
  private avatarUri: string;
  private email: string;
  private name: string;
  private permissions: Permissions;
  private userName$: BehaviorSubject<string>;
  private userAvatar$: BehaviorSubject<string>;
  private isAdmin$: BehaviorSubject<boolean>;
  private userLoggedIn = new Subject<boolean>();
  private status2fa: boolean;

  constructor(
    private storageService: StorageService,
    private backEndCommunicationService: BackEndCommunicationService,
    private readonly keycloak: KeycloakService,
    private readonly router: Router
  ) {
    this.token = '';
    this.isBBRAdmin = true;
    this.avatarUri = '';
    this.email = '';
    this.name = '';
    this.permissions = { deplyMgmt: true, deviceMgmt: true, userMgmt: true };
    this.token = this.storageService.retrieveAuthToken();
    this.isBBRAdmin = this.storageService.retrieveIsAdmin();
    this.avatarUri = this.storageService.retrieveAvatarUri();
    this.email = this.storageService.retrieveEmail();
    this.name = this.storageService.retrieveName();
    this.permissions.deplyMgmt = this.storageService.retrieveDeplyPermission();
    this.permissions.deviceMgmt = this.storageService.retrieveDevicePermission();
    this.permissions.userMgmt = this.storageService.retrieveUserPermission();
    this.userName$ = new BehaviorSubject<string>(this.name);
    this.userAvatar$ = new BehaviorSubject<string>(this.avatarUri);
    this.isAdmin$ = new BehaviorSubject<boolean>(this.isBBRAdmin);
    this.userLoggedIn.next(false);
    this.status2fa = false;
  }

  public isLoggedIn = (): boolean => {
    if (!this.token) {
      return false;
    } else {
      return this.token !== '';
    }
  };

  sendFormContactSales(data: any): any {
    return this.backEndCommunicationService.postResourceObservable('/contact', data);
  }

  public getCompany(): Observable<any> {
    return this.backEndCommunicationService.getResourceObservablePanel('/companies/me');
  }

  public getUserProfile = (): Observable<any> => {
    return this.backEndCommunicationService.getResourceObservablePanel('/users/me');
  };

  public setUserLoggedIn(userLoggedIn: boolean): void {
    this.userLoggedIn.next(userLoggedIn);
  }

  public isAdmin = (): Observable<boolean> => {
    return this.isAdmin$.asObservable();
  };

  public setIsAdmin = (value: boolean): void => {
    this.isBBRAdmin = value;
    this.isAdmin$.next(value);
    this.storageService.storeIsAdmin(this.isBBRAdmin.valueOf());
  };

  public setAvatarUri = (value: string): void => {
    this.avatarUri = value;
    this.storageService.storeAvatarUri(this.avatarUri);
  };

  public setName = (value: string): void => {
    this.name = value;
    this.storageService.storeName(this.name);
  };

  sendFormContactUs(data: any): any {
    this.backEndCommunicationService.postResourceObservable('/contact', data).subscribe((error) => {
      console.log(error);
    });
  }

  closeSession(): void {
    this.logout();
    this.storageService.removelocalStorageData();
    this.setUserLoggedIn(false);
    this.router.navigate(['/public/_home']);
  }

  public logout() {
    this.keycloak.logout();
    this.router.navigate(['/public/_home']);
  }
}
